import { PEOPLE_RULES, PLANT_RULES } from '../../access';

export const USER_CENTER_RULES = {
  manageAccess: PEOPLE_RULES.manageAccess,
  invite: PEOPLE_RULES.invite,
  readPlants: PLANT_RULES.manage,
  readLicenceHistory: PLANT_RULES.licenceHistory,
  manageLicences: PLANT_RULES.manageLicences,
} as const;
